export default __webpack_public_path__ + "static/media/image-board-study-pattern-n-m@3x.23a9d792.png";